import contactBackend from "./contactBackend";

type PresenceStatus = "active" | "away";

type PresencePayload = {
    conversationSid?: string;
    openId?: string;
    serviceType?: string;
    status: PresenceStatus;
};

function getPresenceEndpoint(): string {
    const base = (process.env.REACT_APP_SERVER_URL || "").replace(/\/$/, "");
    return `${base}/chatPresence`;
}

/**
 * 向服务端上报客人是否仍在聊天窗口，供坐席消息决定是否发服务号模板。
 * 关页/点微信 X 时优先 sendBeacon，避免 fetch 被浏览器取消。
 */
export async function reportChatPresence(payload: PresencePayload): Promise<void> {
    const conversationSid = (payload.conversationSid || "").trim();
    if (!conversationSid) {
        return;
    }

    const body = {
        conversationSid,
        openId: payload.openId || "",
        serviceType: payload.serviceType || "",
        status: payload.status
    };

    // 离开场景：页面可能马上销毁，用 beacon 更稳
    if (payload.status === "away" && typeof navigator !== "undefined" && typeof navigator.sendBeacon === "function") {
        try {
            const blob = new Blob([JSON.stringify(body)], { type: "application/json" });
            const queued = navigator.sendBeacon(getPresenceEndpoint(), blob);
            if (queued) {
                return;
            }
        } catch (e) {
            console.warn("reportChatPresence beacon failed", e);
        }
    }

    try {
        await contactBackend("/chatPresence", body);
    } catch (e) {
        console.warn("reportChatPresence failed", e);
    }
}
